import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { withKeyboardAccessibility } from '../Utilities/AccessibilityUtilities';
import Glyphicon from '../Glyphicon/index.js';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const sizeMap = {
  small: 'sm',
  medium: 'md',
  large: 'lg'
};
function IconButton(_ref) {
  let {
    block = false,
    className,
    glyph,
    hideLabel = false,
    label,
    layout = 'horizontal',
    monochrome = false,
    size = 'small',
    muted = false,
    glyphClassName,
    ...rest
  } = _ref;
  let Component = 'button';
  const componentProps = {};
  if (rest?.href) {
    Component = 'a';
  } else {
    componentProps.type = 'button';
  }

  // For sighted users who don't understand what the icon means
  if (hideLabel) {
    componentProps.title = label;
  }
  return /*#__PURE__*/_jsxs(Component, {
    className: clsx(className, 'btn-icon align-items-center', {
      [`btn-icon-${sizeMap[size]}`]: hideLabel,
      'text-size-300': layout !== 'stacked',
      'display-flex': block,
      'display-inline-flex': !block,
      'text-size-200 text-size-sm-400 flex-column': layout === 'stacked',
      'link-unstyled': Component === 'a',
      'btn-icon-muted': muted
    }),
    ...(typeof rest?.onClick === 'function' && {
      onKeyDown: withKeyboardAccessibility(rest.onClick)
    }),
    ...componentProps,
    ...rest,
    children: [/*#__PURE__*/_jsx(Glyphicon, {
      glyph: glyph,
      "aria-hidden": "true",
      className: clsx({
        'text-accent': !monochrome,
        'text-size-300': size === 'small' && hideLabel,
        'text-size-500': size === 'medium' && hideLabel || size !== 'large' && !hideLabel,
        'text-size-650': size === 'large'
      }, glyphClassName)
    }), /*#__PURE__*/_jsx("span", {
      className: clsx('button-icon-label', {
        'sr-only': hideLabel
      }),
      children: label
    })]
  });
}
export default IconButton;